import { IClient } from "api/rpc/2022-09/customer/client";
import { IFacility } from "./models/facility";
import { IBooking, ITeeTime } from "redux/reducers/models/teetime";
import { IUserActive } from "./models/user";
import { ICart } from "./models/cart";
import { IFacilityTeeSheetSettings } from "api/rpc/2024-04/customer/facility";
import { ILocation, IModule, IReservationBooking, ISegment } from "./models/reservations";
import { IAccommodationUnitType } from "pages/secure/facility/accommodation/unitTypes/UnitTypes";

interface IExtendedTeeTime extends ITeeTime {
  formattedStartTime?: string;
  formattedDate?: string;
}

interface ITeeTimeLock {
  lockoutDuration: number;
  lockStartTime: number;
  expireTime: string;
}

interface IRwgToken {
  id: number;
  customer_id: number;
  facility_id: number;
  rwg_token: string;
  expires_at: string;
}

interface IExtendedBooking extends Partial<IBooking> {
  paymentMethodId?: number;
  cart?: ICart;
}

export interface INightlyRate {
  unit_type_id: number;
  planPriceIds: number[];
}

export interface IAccommodationReservation {
  category_id?: number;
  children: number;
  rooms: number;
  adults: number;
  unit_type_id?: number;
  nightly_rates: INightlyRate[];
  arrival_date: Date;
  departure_date: Date;
  currency?: string;
  subtotalPrice?: number;
  totalPrice?: number;
  taxAmount?: number;
  cart_token?: string;
  selectedUnitType?: IAccommodationUnitType;
  nights?: number;
  confirmationNumber?: string;
}

export interface IClientPortalState {
  client: IClient;
  user: IUserActive;
  selectedFacility: Partial<IFacility>;
  teeSheetSettings: IFacilityTeeSheetSettings;
  selectedTeeTime: IExtendedTeeTime;
  selectedTeeTimeLock: ITeeTimeLock;
  postedBooking: IExtendedBooking;
  waitlist_reference_id: string;
  initialQuantity: number;
  accessCode: string;
  usingAccessCode: boolean;
  reservation: {
    location: ILocation;
    segment: ISegment;
    module: IModule;
    booking: IReservationBooking;
    bookedSegments: Array<ISegment>;
    /**The booking endtime */
    endTime: string;
  };
  accommodationReservation: IAccommodationReservation;
  currentRwgToken: IRwgToken;
}

export interface IClientPortalAction {
  type: string;
  payload: Partial<IClientPortalState>;
}

const initialState: IClientPortalState = {
  client: null,
  user: null,
  selectedFacility: null,
  teeSheetSettings: null,
  selectedTeeTime: null,
  selectedTeeTimeLock: null,
  postedBooking: null,
  waitlist_reference_id: null,
  initialQuantity: null,
  accessCode: null,
  usingAccessCode: false,
  reservation: null,
  accommodationReservation: null,
  currentRwgToken: null,
};

export function sortFacilities(facilities: Array<IFacility>) {
  if (facilities) {
    const sortedFacilities = facilities
      ?.sort((prevFacility, nextFacility) => prevFacility?.long_name?.localeCompare(nextFacility?.long_name))
      ?.sort((prevFacility, nextFacilty) => Number(nextFacilty?.favourite) - Number(prevFacility?.favourite));
    return sortedFacilities;
  }
  return [];
}

export default function ClientPortalReducer(state = initialState, action: IClientPortalAction) {
  switch (action.type) {
    case "clientPortal.update":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
